<template>
  <footer
    class="footer"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
  >
    <div class="container">
      <nav>
        <ul>
          <li>
            <a @click="$emit('setCurrentStep', 4)" class="about">
              About
            </a>
          </li>
          <li>
            <a href="https://www.tugraz.at/en/home/" target="_blank">
              <img src='../assets/img/TU_Graz.svg.png' class="TU-logo" @click="reload();">
            </a>
          </li>
          <li>
            <a href="https://www.uni-graz.at/en/" target="_blank">
              <img src='../assets/img/Universität_Graz_logo.svg.png' class="KFU-logo" @click="reload();">
            </a>
          </li>
        </ul>
      </nav>
      <div class="copyright">
        &copy; {{ year }}, Graz University of Technology
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style scoped>

.area {
  width: 100vw;
}

.about {
  margin-left: 3vw;
}

.copyright {
  margin-left: 20vw;
  margin-top: 13px;
  /*position: fixed;*/
}


.TU-logo {
  width: 80px;
  /*margin-left: 5vw;*/
  margin-bottom: 5px;
  /*position: fixed;*/
}

.KFU-logo {
  width: 60px;
  /*margin-left: 15vw;*/
  margin-bottom: 5px;
  /*position: fixed;*/

}



</style>
